import { CardFragment } from 'apps/shared/scripts/graphql/fragments/CardFragment.generated';

import CardFormCreateContainer from './CardFormCreateContainer';
import CardFormUpdateContainer from './CardFormUpdateContainer';

interface Props {
  card?: CardFragment;
}

const CardFormContainer = ({ card, ...props }: Props) => {
  if (card) {
    return <CardFormUpdateContainer card={card} {...props} />;
  }
  return <CardFormCreateContainer {...props} />;
};

CardFormContainer.displayName = 'CardFormContainer';

export default CardFormContainer;
